import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { PaletteGenerator } from "../components/PaletteGenerator";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.cp_tool_name()}
        toolPath="/color-palette"
      />
      <SciHeader title={m.cp_h1()} intro={m.cp_intro()} />
      <PaletteGenerator />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.cp_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.cp_ex1(), m.cp_ex2(), m.cp_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.cp_faq_q1(), a: m.cp_faq_a1() },
          { q: m.cp_faq_q2(), a: m.cp_faq_a2() },
          { q: m.cp_faq_q3(), a: m.cp_faq_a3() },
          { q: m.cp_faq_q4(), a: m.cp_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
